module.exports = {
  key: "fdd508b6c9515fc7e25ce46483d5dfe4",
  base: "https://api.openweathermap.org/data/2.5/",
};
